module.exports = __webpack_public_path__ + "img/2.4.7bdc0b1e.png";